module.exports = __webpack_public_path__ + "img/blog-1.6d350866.webp";